import React from "react";
import "./HTML_MAIN_CSS.css";

const Padding_And_Spacing = () => {
  return (
    <div className="html-container">
      <h1>HTML – Padding & Spacing</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          Padding and spacing in HTML define the amount of space inside and
          between elements. While HTML provides basic attributes like{" "}
          <code>cellpadding</code> and <code>cellspacing</code> for tables,
          modern web design relies on CSS for precise control.
        </p>
      </section>

      {/* 2. Padding */}
      <section id="padding">
        <h2>2. Padding</h2>
        <p>
          Padding is the space between the content of an element and its border.
          You can set padding using CSS:
        </p>
        <pre>
          <code>{`<style>
div {
  padding: 20px; /* top, right, bottom, left */
  background-color: #f0f0f0;
}
</style>

<div>This div has 20px padding all around.</div>`}</code>
        </pre>
        <p>You can also specify individual sides:</p>
        <pre>
          <code>{`div {
  padding-top: 10px;
  padding-right: 15px;
  padding-bottom: 20px;
  padding-left: 25px;
}`}</code>
        </pre>
      </section>

      {/* 3. Margin (Spacing Between Elements) */}
      <section id="margin">
        <h2>3. Margin (Spacing Between Elements)</h2>
        <p>
          Margin is the space outside the element’s border, separating it from
          other elements:
        </p>
        <pre>
          <code>{`<style>
div {
  margin: 20px; /* space outside the element */
  border: 1px solid #333;
  padding: 10px;
}
</style>

<div>This div has 20px margin outside and 10px padding inside.</div>`}</code>
        </pre>
        <p>Individual sides can also be controlled:</p>
        <pre>
          <code>{`div {
  margin-top: 10px;
  margin-right: 15px;
  margin-bottom: 20px;
  margin-left: 25px;
}`}</code>
        </pre>
      </section>

      {/* 4. Table Spacing */}
      <section id="table-spacing">
        <h2>4. Table Padding & Spacing</h2>
        <p>Older HTML attributes (not recommended) for table spacing:</p>
        <pre>
          <code>{`<table border="1" cellpadding="10" cellspacing="5">
  <tr>
    <th>Name</th>
    <th>Age</th>
  </tr>
  <tr>
    <td>John</td>
    <td>25</td>
  </tr>
</table>`}</code>
        </pre>
        <p>Modern approach: use CSS:</p>
        <pre>
          <code>{`table {
  border-collapse: separate;
  border-spacing: 10px; /* spacing between cells */
}

th, td {
  padding: 15px; /* inner spacing */
}`}</code>
        </pre>
      </section>

      {/* 5. Shorthand for Padding & Margin */}
      <section id="shorthand">
        <h2>5. Shorthand for Padding & Margin</h2>
        <p>CSS allows shorthand notation:</p>
        <pre>
          <code>{`/* top right bottom left */
padding: 10px 15px 20px 25px;
margin: 5px 10px 15px 20px;

/* top-bottom left-right */
padding: 10px 20px;
margin: 15px 30px;

/* all sides same */
padding: 20px;
margin: 10px;`}</code>
        </pre>
      </section>

      {/* 6. Summary */}
      <section id="summary">
        <h2>6. Summary</h2>
        <ul>
          <li>Padding: inner space between content and border.</li>
          <li>Margin: outer space between elements.</li>
          <li>
            Use CSS instead of old HTML attributes for tables (
            <code>cellpadding</code> & <code>cellspacing</code>).
          </li>
          <li>Shorthand notation simplifies CSS for padding and margin.</li>
          <li>Proper spacing improves readability and layout consistency.</li>
        </ul>
      </section>
    </div>
  );
};

export default Padding_And_Spacing;
